import { useEffect, useRef, useState } from "react";
import { useInView } from "framer-motion";

const CHARS = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789#*<>/[]{}";

// Console-style "decode" reveal: letters scramble then resolve when in view.
export default function ScrambleText({ text, as: Tag = "span", className = "", delay = 0 }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-70px" });
  const [display, setDisplay] = useState(text);

  useEffect(() => {
    if (!inView) return undefined;
    let raf;
    let frame = 0;
    const start = () => {
      const id = setInterval(() => {
        frame += 1;
        const revealed = Math.floor(frame / 2);
        let out = "";
        for (let i = 0; i < text.length; i += 1) {
          if (text[i] === " ") {
            out += " ";
          } else if (i < revealed) {
            out += text[i];
          } else {
            out += CHARS[Math.floor(Math.random() * CHARS.length)];
          }
        }
        setDisplay(out);
        if (revealed >= text.length) clearInterval(id);
      }, 28);
      return id;
    };
    const to = setTimeout(() => {
      raf = start();
    }, delay);
    return () => {
      clearTimeout(to);
      clearInterval(raf);
    };
  }, [inView, text, delay]);

  return (
    <Tag ref={ref} className={className}>
      {display}
    </Tag>
  );
}
